/**
 * @generated SignedSource<<7a6933cc4673e4429acf601bc332c718>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsDatavizSearch_participativeModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizTabs_participativeModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizSearchFilters_participativeModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizSearchResults_participativeModule"
    }
  ],
  "type": "ParticipativeModule",
  "abstractKey": null
};

node.hash = "37fcc2a2d4ad3820718c2d065d9fd211";

module.exports = node;
